import _ from 'lodash';
import { createSelector } from 'reselect'

import { TimeHelpers, orderOffsetSelector } from '@arreeba/ristoranti-frontend-lib';

import { COMMON_LOCALIZED } from '../lib/localized';
import { urlSelector } from './urlSelectors';

export const currentRestaurantSelector = createSelector(
  state => state.app.merchant.restaurants,
  urlSelector,
  (restaurants, url) => {
    if (!url.restaurantId) {
      return null;
    }
    return _.find(restaurants, { id: url.restaurantId });
  },
);

export const currentRestaurantTimesSelector = createSelector(
  currentRestaurantSelector,
  (state, props) => props.url.orderType,
  orderOffsetSelector,
  (restaurant, orderType, offset) => {
    if (!restaurant || !orderType) {
      return null;
    }
    const times = orderType === 'delivery' ?
      restaurant.deliveryTimes :
      restaurant.takeAwayTimes;

    return (
      TimeHelpers
        .mapTimesToHumanTimes(offset, times, COMMON_LOCALIZED, true)
        .reduce((acc, d) => {
          return {
            ...acc,
            [d.value]: d,
          };
        }, {})
    );
  },
);



// WEBPACK FOOTER //
// ./src/selectors/restaurantSelectors.js